export default "__VITE_ASSET__DNpiv_80__"